import React from 'react';
import { View, StyleSheet } from 'react-native';
import { Text } from '@/components/common/text';
import { useAdminColors } from '@/hooks/admin/useAdminColors';
import type { SentimentTheme } from '@/types/sentiment';
import { displayTheme } from '@/utils/sentiment/displayTheme';

interface Props {
  themes: SentimentTheme[];
}

export const ThemeTagList: React.FC<Props> = ({ themes }) => {
  const { redesign } = useAdminColors();
  if (themes.length === 0) return null;

  return (
    <View style={styles.row}>
      {themes.map(t => (
        <View
          key={t.theme}
          style={[styles.tag, { backgroundColor: redesign.card.bgStrong }]}
        >
          <Text style={[styles.text, { color: redesign.text.secondary }]}>
            {displayTheme(t.theme)} · {t.frequency}
          </Text>
        </View>
      ))}
    </View>
  );
};

const styles = StyleSheet.create({
  row: { flexDirection: 'row', flexWrap: 'wrap', gap: 6, marginTop: 6 },
  tag: {
    paddingHorizontal: 6,
    paddingVertical: 2,
    borderRadius: 10,
  },
  text: { fontSize: 12 },
});
